import { Facebook } from "lucide-react";
import WolfCrest from "./WolfCrest";

export default function Footer({ onNavigate }) {
  return (
    <footer className="bg-[#122E4D] text-[#F8F9FA] py-16 md:py-20 px-5 md:px-10 border-t border-white/10" data-testid="footer">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <WolfCrest className="w-10 h-10" />
              <div>
                <p className="font-serif font-bold tracking-wide">WILLIAMS</p>
                <p className="text-[10px] uppercase tracking-[0.3em] text-white/85">For MHA Nation Chairman</p>
              </div>
            </div>
            <p className="text-white/85 text-sm max-w-xs leading-relaxed">
              Your government. Your voice. Our shared vision — for the Mandan, Hidatsa &amp; Arikara Nation.
            </p>
            <a
              href="https://www.facebook.com/DaveWilliamsforMHA/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 mt-6 text-white/85 hover:text-gold transition-colors duration-300"
              data-testid="footer-facebook-link"
            >
              <Facebook className="w-4 h-4" />
              <span className="text-[11px] uppercase tracking-[0.2em] font-semibold">Follow the campaign on Facebook</span>
            </a>
          </div>

          <nav className="grid grid-cols-2 gap-x-16 gap-y-3 text-sm" aria-label="Footer">
            {[
              ["Story", "#story"],
              ["Platform", "#platform"],
              ["Events", "#events"],
              ["Voter Info", "#vote"],
              ["Sign Up", "#signup"],
            ].map(([label, href]) => (
              <button
                key={href}
                onClick={() => onNavigate(href)}
                className="text-left text-white/85 hover:text-gold transition-colors duration-300"
                data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {label}
              </button>
            ))}
          </nav>

          <div className="text-sm text-white/85">
            <p className="text-[10px] uppercase tracking-[0.3em] mb-3">Election Day</p>
            <p className="font-serif text-2xl font-bold text-[#F8F9FA]">Nov 3, 2026</p>
            <p className="mt-1">Polls 7 AM – 7 PM CT</p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/60">
          <p>Paid for by Friends of David Williams. Not authorized by any tribal government entity.</p>
          <p>© 2026 Williams for MHA Nation. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
